module.exports = __webpack_public_path__ + "img/shsdyrmyy.21b6f76e.png";